"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActivityDurationHours = getActivityDurationHours;
exports.getChecksum = getChecksum;

var _moment = _interopRequireDefault(require("moment"));

var _md = _interopRequireDefault(require("tiny-hashes/md5"));

/**
 * Returns the duration in hours between the start and end of an activity
 * @param {Activity} activity Activity
 * @returns {number} Duration in hours between start and end of an activity. Returns null if no endDatetime
 */
function getActivityDurationHours(activity) {
  var precise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!activity.endDatetime) {
    return null;
  }

  return (0, _moment["default"])(activity.endDatetime).diff((0, _moment["default"])(activity.datetime), 'hours', precise);
}
/**
 * Returns the md5-checksum of an object
 * @param {*} obj
 */


function getChecksum(obj) {
  return (0, _md["default"])(JSON.stringify(obj));
}